import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=55cadd1a&"
import script from "./StarIcon.vue?vue&type=script&lang=js&"
export * from "./StarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports